import { useState } from "react";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { auth } from "../firebase";
import { Link, useNavigate } from "react-router-dom";
import { validatePassword } from "../utils/validatePassword";
import PasswordInput from "../components/PasswordInput";
import ForageLogo from "../components/ForageLogo";

export default function SignupPage(){

  const navigate = useNavigate();

  const [name,     setName]     = useState("");
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [confirm,  setConfirm]  = useState("");
  const [error,    setError]    = useState("");
  const [loading,  setLoading]  = useState(false);

  async function handleSignup(){

    if(password !== confirm){
      setError("Passwords do not match.");
      return;
    }

    const missing = validatePassword(password);
    if(missing.length > 0){
      setError(`Password must contain: ${missing.join(", ")}.`);
      return;
    }

    setLoading(true);
    setError("");

    try{
      const userCred = await createUserWithEmailAndPassword(auth, email, password);
      await updateProfile(userCred.user, { displayName: name });
      navigate("/setup");
    } catch(err){
      setError(err.message);
    } finally {
      setLoading(false);
    }

  }

  function handleKeyDown(e){
    if(e.key === "Enter") handleSignup();
  }

  return(

    <div className="authLayout">

      {/* LEFT PANEL */}
      <div className="authBrand">
        <div className="authBrandLogo">
          <ForageLogo size={48} color="#c8dba8" />
        </div>
        <h1>Forage</h1>
        <p className="authBrandTagline">
          Your household's home for<br />
          meals, groceries, and pantry.
        </p>
        <ul className="authFeatureList">
          <li>Plan meals for the whole week</li>
          <li>Build and browse your recipe library</li>
          <li>Track your pantry and shop smarter</li>
        </ul>
      </div>

      {/* RIGHT PANEL */}
      <div className="authFormArea">

        <div className="authBox">

          <h2>Create Account</h2>

          {error && <p className="error">{error}</p>}

          <div className="authField">
            <label htmlFor="signup-name">Full Name</label>
            <input
              id="signup-name"
              type="text"
              autoComplete="name"
              placeholder="Jane Smith"
              value={name}
              onChange={e=>setName(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>

          <div className="authField">
            <label htmlFor="signup-email">Email</label>
            <input
              id="signup-email"
              type="email"
              autoComplete="email"
              placeholder="you@example.com"
              value={email}
              onChange={e=>setEmail(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>

          <div className="authField">
            <label htmlFor="signup-password">Password</label>
            <PasswordInput
              id="signup-password"
              placeholder="Create a password"
              value={password}
              onChange={e=>setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>

          <div className="authField">
            <label htmlFor="signup-confirm">Confirm Password</label>
            <PasswordInput
              id="signup-confirm"
              placeholder="Repeat your password"
              value={confirm}
              onChange={e=>setConfirm(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>

          <button onClick={handleSignup} disabled={loading}>
            {loading ? "Creating account…" : "Create Account"}
          </button>

          <p className="authSwitch">
            Already have an account?
            <Link to="/"> Login</Link>
          </p>

        </div>

      </div>

    </div>

  );

}
